import { render, staticRenderFns } from "./UpsSetupForm.vue?vue&type=template&id=4c48ba46&"
import script from "./UpsSetupForm.vue?vue&type=script&lang=js&"
export * from "./UpsSetupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports